import { computed, watchEffect, Ref } from 'vue';
import useContentCollection from './use-content-collection';
import useContentCollectionsStore from './content-collections';
import type { BaseState, ContentCollection } from '@ilteducation/content-collections-types';

export type ReservedCollectionParams = {
  collectionId: string;
  name: string;
  icon: string;
  context: string;
};

const createDefaultCollection = ({
  collectionId,
  name,
  icon,
  context,
}: ReservedCollectionParams): ContentCollection => ({
  id: collectionId,
  name,
  icon,
  context,
  legacyId: 0,
  contents: {
    type: 'ContentsByReferences',
    references: [],
  },
  state: 'active' as BaseState,
  realm: 'dummyRealm',
});

const useReservedCollection = (params: Ref<ReservedCollectionParams>) => {
  const collectionId = computed(() => params.value.collectionId);

  const collectionsStore = useContentCollectionsStore();
  const { collection, isLoading, hasContent, addContents, removeContents } = useContentCollection(collectionId);

  watchEffect(() => {
    if (collectionsStore.collectionById(collectionId) === null) {
      // add a dummy collection for the reserved collection, if the collection does not yet exist
      collectionsStore.put([createDefaultCollection(params.value)]);
    }
  });

  const collectionWithFallback = computed(() => collection.value ?? createDefaultCollection(params.value));

  return {
    collection: collectionWithFallback,
    isLoading,
    hasContent,
    addContents,
    removeContents,
  };
};

export default useReservedCollection;
